module.exports = __webpack_public_path__ + "static/img/wuxi2.7ed75ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/wuxi2.jpg
// module id = Yjf0
// module chunks = 1